import React from 'react';
import useApiRequests from '../../../hooks/useApiRequests';


export default function AuthWithCode() {
  const { authWithCode } = useApiRequests();  

  React.useEffect(() => {
    const fetchData = async () => {
      const code = window.location.href.split('/').pop();
      const data = await authWithCode(code || "");
    };
  
    fetchData();
  }, []);
  

  return (
    <div>
      Auth With code
    </div>
  )
}
